// @ts-expect-error
// eslint-disable-next-line import/no-unresolved
import filenamify from 'filenamify/browser';

export const sanitizeFilename = (filename: string) => {
  // ReadSettingsFromSourceSequence in DVA has a max length of 230
  return filenamify(filename, {
    maxLength: 230,
    replacement: '',
  });
};
